export enum ModifyAccessLevel {
  UNKNOW = 0,
  BASIC = UNKNOW,
  SILVER = 1,
  PLATINIUM = SILVER,
  GOLD = 2,
  DIAMOND = GOLD,
}
